import { createTheme } from "@mui/material/styles";

/*
 * The same iotmatrix green the RAG portal uses. The console and the portal are the two
 * faces the customer sees of one company, and a second, nearly-matching green is how the
 * two start to look like different products.
 */
const theme = createTheme({
    palette: {
        primary: { main: "#2E7D20", dark: "#24651A", light: "#E9F6E5", contrastText: "#ffffff" },
        secondary: { main: "#1A1A1A" },
        background: { default: "#F4F6F8" },
        success: { main: "#2E7D20" },
    },
    shape: { borderRadius: 12 },
    typography: {
        fontFamily: "'Inter', 'Segoe UI', Roboto, Arial, sans-serif",
        button: { textTransform: "none", fontWeight: 600 },
    },
    components: {
        MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                /*
                 * Every disabled button, on a dark page.
                 *
                 * MUI greys them with a near-black meant for white paper. On a filled
                 * button that leaves faint text; on a text or outlined one the whole
                 * control vanishes, and a button nobody can see reads as a missing
                 * feature rather than one waiting for input. The coupon field's Apply
                 * disappeared this way until something was typed.
                 */
                root: {
                    "&.Mui-disabled": { color: "rgba(255,255,255,.35)" },
                },

                /*
                 * A disabled filled button, on a dark page.
                 *
                 * MUI greys it out against a light background by default, which on these
                 * screens is dark-on-dark - the button vanishes, and a form with nothing
                 * to press reads as broken rather than incomplete. A faint green keeps it
                 * visible while still looking untouchable.
                 */
                contained: {
                    "&.Mui-disabled": {
                        backgroundColor: "rgba(123,217,95,.18)",
                        color: "rgba(255,255,255,.45)",
                    },
                },
            },
        },
    },
});

export default theme;
